import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AuthService} from "../auth/auth.service";
import {UntypedFormControl} from "@angular/forms";
import {Router} from "@angular/router";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {ChangePasswordComponent} from "../change-password/change-password.component";
import {showAnimation} from "../app.component";
import {ResetPasswordComponent} from "../reset-password/reset-password.component";



@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],
  animations: [showAnimation]
})
export class SignInComponent implements OnInit {

  constructor(
    private auth: AuthService,
    private router: Router,
    public signInDialogRef: MatDialogRef<SignInComponent>,
    public changePasswordDialog: MatDialog
  ) { }

  @Output() close: EventEmitter<any> = new EventEmitter();

  username = new UntypedFormControl('');
  password = new UntypedFormControl('');

  errorMessage:string | undefined = undefined;

  ngOnInit(): void {
  }

  signIn() {
    this.auth.signInADFS()
  }

  signInExternal() {
    this.auth.signInExternal(this.username.value.toLowerCase(), this.password.value).subscribe(
      user => {
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.openChangePasswordDialog(user)
        } else {
          this.router.navigate(['/upload'])
          this.signInDialogRef.close()
        }
      },
      error => {
        console.log(error);
        if(error.code === 'UserNotFoundException') {
          this.errorMessage = 'Incorrect username or password.'
        } else {
          this.errorMessage = error.message;
        }
      }
    )
  }

  forgotPassword() {
    this.openResetPasswordDialog()
  }

  openChangePasswordDialog(user: any) {
    this.changePasswordDialog.open(ChangePasswordComponent, {
      data: user
    }).afterClosed().subscribe(
      () => {
        this.signInDialogRef.close()
      }
    );
  }

  openResetPasswordDialog() {
    this.changePasswordDialog.open(ResetPasswordComponent, {
      data: this.username.value
    })
  }
}
